import React, { useEffect, useState } from 'react'
import Accordion from '../../atoms/Accordion/Accordion'
import Button from '../../atoms/Button/Button'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import { Bin, CartNormal, Edit, Info } from '../../atoms/NewIcons'
import { Trans } from '../../atoms'
import useTrans from '../../../hooks/useTrans'
import { useRouter } from 'next/router'
import { createToken } from '../../../pages/cart/checkout/[token]'
import { priceNotation } from '../../../utils/safe'
import LoadingSvg from '../../atoms/Loading/Loading'
import { useSelector } from 'react-redux'

//Cambiare Icon e introdurre Icon nei Button
const OrdineRiepilogoCardCarrello = ({
  ordine,
  isCheckout,
  isReady,
  consegnaPrevista,
  AddToCartMain,
  SaveLater,
  isProdotto,
  prodotto,
  ModificaArticoli,
  onCheckout,
  disabledCheckout,
  ConfermaOrdine,
  setEditArticoloProps,
  isLoading,
  isPersonalizzazione,
  OrdinaSubito,
}) => {
  const t = useTrans()
  const router = useRouter()
  const [altriCosti, setaltriCosti] = useState(0)
  const [costiTrasporto, setCostiTrasporto] = useState(0)
  const [costiRitiro, setCostiRitiro] = useState(0)
  const [codiceSconto, setCodiceSconto] = useState()
  const [disabled, setDisabled] = useState(true)
  const [expanded, setExpanded] = useState(false)
  const { service_gift } = useSelector((state) => state?.servicegift)

  useEffect(() => {
    if (ordine) {
      setDisabled(false)
      setCostiTrasporto(ordine.valore_trasporto ? ordine.valore_trasporto : 0)
      setCostiRitiro(ordine.valore_ritiro ? ordine.valore_ritiro : 0)
      setaltriCosti(
        ordine.valore_impianto +
          ordine.valore_gestione +
          ordine.valore_siae +
          ordine?.valore_supplementi_minimi_stampa +
          ordine?.valore_tracciatura_logo
      )
    } else {
      setCostiTrasporto(0)
      setCostiRitiro(0)
      setaltriCosti(0)
      setCodiceSconto(0)
    }

    !ordine && setDisabled(true)
  }, [ordine])

  const Lavorazione = (item) => {
    let pers = (
      <>
        <div className="riepilogo-card-carrello__accordion-row">
          <div className="riepilogo-card-carrello__accordion-code">{item.nome_lavorazione}</div>
          <div className="riepilogo-card-carrello__accordion-qty"></div>
          <div className="riepilogo-card-carrello__accordion-price"></div>
        </div>
        {item.righe_carrello.map((element) => (
          <div className="riepilogo-card-carrello__accordion-row" key={element.id}>
            <div className="riepilogo-card-carrello__accordion-code">{element.articolo.codice}</div>
            <div className="riepilogo-card-carrello__accordion-qty">
              x {element.quantita} {t('pz')}
            </div>
            <div className="riepilogo-card-carrello__accordion-price">
              {priceNotation(element.prezzo_personalizzazione_unitario * element.quantita, 2)} €
            </div>
          </div>
        ))}
        {/* {item.totale_confezionamento > 0 && (
          <div className="riepilogo-card-carrello__accordion-row">
            <div className="riepilogo-card-carrello__accordion-code">
              <Trans chiave="Totale Confezionamento" />
            </div>
            <div className="riepilogo-card-carrello__accordion-price">
              {priceNotation(item.totale_confezionamento, 3)} €
            </div>
          </div>
        )} */}
      </>
    )
    return pers
  }
  return (
    <>
      {expanded && (
        <div className="riepilogo-card-carrello-overlay" onClick={() => setExpanded(false)}></div>
      )}
      <div
        className={`riepilogo-card-carrello ${isProdotto && 'riepilogo-card-carrello--prodotto'} ${
          expanded && ' riepilogo-card-carrello--expanded'
        }`}
      >
        <div
          className="riepilogo-card-carrello__icon-container"
          onClick={() => setExpanded(!expanded)}
        >
          <CartNormal />
        </div>
        <div className="riepilogo-card-carrello__content">
          <div className="riepilogo-card-carrello__head" onClick={() => setExpanded(!expanded)}>
            <p className="riepilogo-card-carrello__title">
              {isProdotto ? <>{t('Calcolo preventivo')}</> : <>{t('Riepilogo Ordine')}</>}
            </p>
            <p className="riepilogo-card-carrello__subtitle">
              <>
                <span>
                  <Trans chiave="Totale" />:{' '}
                </span>
                <span>{priceNotation(ordine?.totale, 2)} €</span>
              </>
            </p>
          </div>
          {isLoading ? (
            <div className="riepilogo-card-carrello__loading">
              <LoadingSvg />
            </div>
          ) : (
            <>
              <div className="riepilogo-card-carrello__rows-container">
                <div className="riepilogo-card-carrello__rows-container--child">
                  {ordine?.personalizzazioni_carrello?.length > 0 ||
                  ordine?.righe_carrello_merce_neutra?.length > 0 ? (
                    <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--accordion">
                      <Accordion
                        withoutBorder
                        placeholder={t('Merce Neutra')}
                        size="small"
                        placeholderEllipses={true}
                        className="riepilogo-card-carrello__accordion"
                      >
                        {ordine?.righe_carrello_merce_neutra?.map((item) => (
                          <div className="riepilogo-card-carrello__accordion-row" key={item.id}>
                            <div className="riepilogo-card-carrello__accordion-code">
                              {item.articolo.codice}
                            </div>
                            <div className="riepilogo-card-carrello__accordion-qty">
                              x {item.quantita} pz
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(item.totale, 2)} €
                            </div>
                            {!isCheckout && setEditArticoloProps && (
                              <div className="riepilogo-card-carrello__accordion-actions">
                                <div
                                  onClick={() => {
                                    const selected = prodotto.articoli.filter(
                                      (articolo) => articolo?.codice === item.articolo?.codice
                                    )[0]

                                    setEditArticoloProps({
                                      initialStep: 1,
                                      initialSelectedArticolo: selected,
                                      show: true,
                                      initialId: item.id,
                                      initialQuantita: item.quantita,
                                    })
                                  }}
                                >
                                  <Edit />
                                </div>
                                <div
                                  onClick={() => {
                                    setEditArticoloProps((prev_state) => ({
                                      ...prev_state,
                                      initialId: item.id,
                                      show_delete: true,
                                    }))
                                  }}
                                >
                                  <Bin />
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                        {ordine?.personalizzazioni_carrello?.map((item) =>
                          item.righe_carrello.map((element) => (
                            <div className="riepilogo-card-carrello__accordion-row">
                              <div className="riepilogo-card-carrello__accordion-code">
                                {element.articolo.codice}
                              </div>
                              <div className="riepilogo-card-carrello__accordion-qty">
                                x {element.quantita} {t('pz')}
                              </div>
                              <div className="riepilogo-card-carrello__accordion-price">
                                {priceNotation(element.totale, 2)} €
                              </div>
                              {!isCheckout && setEditArticoloProps && (
                                <div className="riepilogo-card-carrello__accordion-actions">
                                  <div
                                    onClick={() => {
                                      const selected = prodotto.articoli.filter(
                                        (articolo) => articolo?.codice === element.articolo?.codice
                                      )[0]

                                      setEditArticoloProps({
                                        initialStep: 1,
                                        initialSelectedArticolo: selected,
                                        show: true,
                                        initialId: element.id,
                                        initialQuantita: element.quantita,
                                      })
                                    }}
                                  >
                                    <Edit />
                                  </div>
                                  <div
                                    onClick={() => {
                                      setEditArticoloProps((prev_state) => ({
                                        ...prev_state,
                                        initialId: element.id,
                                        show_delete: true,
                                      }))
                                    }}
                                  >
                                    <Bin />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))
                        )}
                        {/* {ordine?.personalizzzazioni_carrello?.map((item) => (
                        <div className="riepilogo-card-carrello__accordion-row">
                          <div className="riepilogo-card-carrello__accordion-code">
                            {item.articolo.codice}
                          </div>
                          <div className="riepilogo-card-carrello__accordion-qty">
                            x {item.quantita} {t('pz')}
                          </div>
                          <div className="riepilogo-card-carrello__accordion-price">
                            {priceNotation(item.totale, 3)} €{console.log(item)}
                          </div>
                          {!isCheckout && setEditArticoloProps && (
                            <div className="riepilogo-card-carrello__accordion-actions">
                              <div
                                onClick={() => {
                                  const selected = prodotto.articoli.filter(
                                    (articolo) => articolo?.codice === item.articolo?.codice
                                  )[0]

                                  setEditArticoloProps({
                                    initialStep: 1,
                                    initialSelectedArticolo: selected,
                                    show: true,
                                    initialId: item.id,
                                    initialQuantita: item.quantita,
                                  })
                                }}
                              >
                                <Edit />
                              </div>
                              <div
                                onClick={() => {
                                  setEditArticoloProps((prev_state) => ({
                                    ...prev_state,
                                    initialId: item.id,
                                    show_delete: true,
                                  }))
                                }}
                              >
                                <Bin />
                              </div>
                            </div>
                          )}
                        </div>
                      ))} */}
                        {/* TODO: valorizzare correttamente */}
                      </Accordion>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(ordine?.valore_merce, 2)} €
                      </p>
                    </div>
                  ) : (
                    <div className="riepilogo-card-carrello__row">
                      <p>{t('Merce Neutra')}</p>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(ordine?.valore_merce, 2)} €
                      </p>
                    </div>
                  )}
                  {ordine?.personalizzazioni_carrello?.length > 0 && (
                    <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--accordion">
                      <Accordion
                        withoutBorder
                        placeholder={t('Personalizzazione')}
                        size="small"
                        placeholderEllipses={true}
                        className="riepilogo-card-carrello__accordion"
                      >
                        {ordine?.personalizzazioni_carrello?.map((item) => Lavorazione(item))}
                      </Accordion>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(ordine?.valore_personalizzazione, 2)} €
                      </p>
                    </div>
                  )}

                  {ordine?.valore_confezionamento > 0 && (
                    <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--accordion">
                      <Accordion
                        withoutBorder
                        placeholder={t('Confezionamento')}
                        size="small"
                        placeholderEllipses={true}
                        className="riepilogo-card-carrello__accordion"
                      >
                        {ordine?.personalizzazioni_carrello?.map(
                          (riga) =>
                            riga.totale_confezionamento > 0 && (
                              <>
                                <div className="riepilogo-card-carrello__accordion-row">
                                  <p>{riga?.nome_lavorazione}</p>
                                </div>

                                {riga?.righe_carrello?.map((item) => (
                                  <div className="riepilogo-card-carrello__accordion-row">
                                    <div className="riepilogo-card-carrello__accordion-label">
                                      <p>
                                        {item?.articolo?.codice + ' '} x {item?.quantita} pz
                                      </p>
                                    </div>
                                    <div className="riepilogo-card-carrello__accordion-price">
                                      {priceNotation(
                                        item?.prezzo_confezionamento * item?.quantita,
                                        2
                                      )}{' '}
                                      €
                                    </div>
                                  </div>
                                ))}
                              </>
                            )
                        )}
                      </Accordion>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(ordine?.valore_confezionamento, 2)} €
                      </p>
                    </div>
                  )}

                  {altriCosti != 0 && (
                    <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--accordion">
                      <Accordion
                        withoutBorder
                        placeholder={t('Altri Costi')}
                        size="small"
                        placeholderEllipses={true}
                        className="riepilogo-card-carrello__accordion"
                      >
                        {ordine.valore_impianto > 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="Impianto" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_impianto, 2)} €
                            </div>
                          </div>
                        )}
                        {ordine.valore_gestione > 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="Avviamento" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_gestione, 2)} €
                            </div>
                          </div>
                        )}

                        {ordine.valore_siae > 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="SIAE" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_siae, 2)} €
                            </div>
                          </div>
                        )}

                        {ordine?.valore_supplementi_minimi_stampa > 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="Supplementi minimi stampa" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_supplementi_minimi_stampa, 2)} €
                            </div>
                          </div>
                        )}

                        {ordine?.valore_tracciatura_logo > 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="Tracciatura logo" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_tracciatura_logo, 2)} €
                            </div>
                          </div>
                        )}
                      </Accordion>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(altriCosti, 2)} €
                      </p>
                    </div>
                  )}
                  {ordine && ordine?.valore_sconto_imballi_integri != 0 && (
                    <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--accordion">
                      <Accordion
                        withoutBorder
                        placeholder={t('Sconti')}
                        size="small"
                        placeholderEllipses={true}
                        className="riepilogo-card-carrello__accordion"
                      >
                        {ordine?.valore_sconto_imballi_integri != 0 && (
                          <div className="riepilogo-card-carrello__accordion-row">
                            <div className="riepilogo-card-carrello__accordion-label">
                              <Trans chiave="Sconto imballi" />
                            </div>
                            <div className="riepilogo-card-carrello__accordion-price">
                              {priceNotation(ordine?.valore_sconto_imballi_integri, 2)} €
                            </div>
                          </div>
                        )}
                      </Accordion>
                      <p className="riepilogo-card-carrello__price">
                        {priceNotation(ordine?.valore_sconto_imballi_integri, 2)} €
                      </p>
                    </div>
                  )}

                  <div className="riepilogo-card-carrello__row">
                    <p>
                      {costiRitiro ? t('Ritiro') : t('Spedizione')}{' '}
                      <span className="riepilogo-card-carrello__spedizione-info">
                        {!isCheckout && !costiRitiro && (
                          <Tooltip
                            label={t(
                              'Il calcolo del trasporto è indicativo sulla base degli articoli presenti nel preventivo e della destinazione principale'
                            )}
                            id={'tt-ordineriepilogocard-spedizione'}
                            size="sm"
                          >
                            <Info />
                          </Tooltip>
                        )}
                      </span>{' '}
                    </p>
                    <p>{priceNotation(costiRitiro ? costiRitiro : costiTrasporto, 2)} €</p>
                  </div>

                  {ordine?.totale_imponibile > 0 && (
                    <div className="riepilogo-card-carrello__row">
                      <p>{t('Totale Netto')}</p>
                      <p>{priceNotation(ordine?.totale_imponibile, 2)} €</p>
                    </div>
                  )}

                  {ordine?.totale_imposta > 0 && (
                    <div className="riepilogo-card-carrello__row">
                      <p>{t('IVA')}</p>
                      <p>{priceNotation(ordine?.totale_imposta, 2)} €</p>
                    </div>
                  )}
                </div>
                <div className="riepilogo-card-carrello__totale">
                  <div className="riepilogo-card-carrello__row riepilogo-card-carrello__row--totale">
                    <p>{t('Totale')}</p>
                    <p>{priceNotation(ordine?.totale, 2)} €</p>
                  </div>
                </div>

                {isCheckout ? (
                  <>
                    {consegnaPrevista && (
                      <div className="riepilogo-card-carrello__consegna-prevista">
                        <p className="riepilogo-card-carrello__consegna-prevista__label">
                          {t('Data prevista di consegna')}
                        </p>
                        <p className="riepilogo-card__consegna-prevista__value">
                          {consegnaPrevista}
                        </p>
                        <div className="riepilogo-card__consegna-prevista__merce_personalizzata">
                          {ordine?.personalizzazioni_carrello?.length > 0 && (
                            <Tooltip
                              label={t(
                                'Data di consegna potrebbe variare in base alla data di approvazione della bozza digitale o del campione fisico'
                              )}
                            >
                              <Info />
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="riepilogo-card-carrello__buttons">
                      <Button
                        onClick={() => ConfermaOrdine()}
                        label={t('Conferma Ordine')}
                        disabled={!isReady ? true : false}
                        variant="primary"
                        size="medium"
                        className="riepilogo-card-carrello__button"
                      />
                    </div>
                  </>
                ) : isProdotto ? (
                  <div className="riepilogo-card-carrello__buttons">
                    <Button
                      disabled={disabled}
                      label={t('Aggiungi al carrello')}
                      variant="primary"
                      size="medium"
                      onClick={AddToCartMain}
                      className="riepilogo-card-carrello__button riepilogo-card-carrello__button--addcart"
                    />
                    {ordine?.checkout_rapido_abilitato && !isPersonalizzazione && (
                      <Button
                        disabled={disabled}
                        label={t('Ordina subito')}
                        variant="primary"
                        size="medium"
                        onClick={OrdinaSubito}
                        className="riepilogo-card-carrello__button riepilogo-card-carrello__button--addcart"
                      />
                    )}
                    {!isPersonalizzazione && (
                      <Button
                        disabled={disabled}
                        label={t('Salva per dopo')}
                        variant="secondary"
                        size="medium"
                        onClick={SaveLater}
                        className="riepilogo-card-carrello__button"
                      />
                    )}
                    {!isPersonalizzazione && (
                      <Button
                        disabled={disabled}
                        label={t('Modifica articoli')}
                        variant="ghost"
                        size="medium"
                        onClick={ModificaArticoli}
                        className="riepilogo-card-carrello__button"
                      />
                    )}
                  </div>
                ) : (
                  <div className="riepilogo-card-carrello__buttons">
                    <Button
                      disabled={disabledCheckout && disabledCheckout}
                      bg={disabledCheckout && 'grey'}
                      label={t("Prosegui con l'ordine")}
                      variant="primary"
                      size="medium"
                      onClick={() => onCheckout && onCheckout()}
                      className="riepilogo-card-carrello__button"
                    />

                    {ordine && !service_gift && (
                      <Button
                        disabled={
                          !(
                            ordine?.righe_carrello_merce_neutra?.length > 0 ||
                            ordine?.personalizzazioni_carrello?.length > 0
                          )
                        }
                        label={t('Crea offerta')}
                        variant="secondary"
                        size="medium"
                        onClick={() => router?.push(`/crea-offerta?cart=${ordine?.id}`)}
                        className="riepilogo-card-carrello__button"
                      />
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default React.memo(OrdineRiepilogoCardCarrello)
